import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Typography, Icon, Button, ButtonMenu } from '@ann/web-components';
import { CardContainer, CardWrapper, RightSpace, AssisnedUsersContainer } from './RoleCard.styled';

const RoleCard = ({ id, title, description, roleData, onClick, onAssignClick }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (onClick) {
      onClick(id);
    }
  };

  const handleViewDetails = (e) => {
    e.stopPropagation(); // Prevent card click event
    navigate(`/v2/user-management/roles/${id}`, {
      state: { 
        roleName: title,
        roleDescription: description,
        roleData: roleData
      }
    });
  };

  const handleMenuChange = (value) => {
    if (value === 'assign_role') {
      if (onAssignClick) {
        onAssignClick({ id, title, description, roleData });
      }
    }
  };

  return (
    <div>
      <Card onClick={handleCardClick}>
        <CardWrapper>
          <CardContainer>
            <Typography category="subtitle" size="small" weight="bold">
              {title}
            </Typography>
            <Typography category="body" size="small" weight="regular" color="body" maxCharacters={50}>
              {description}
            </Typography>
          </CardContainer>

          <RightSpace>
            {/*<AssisnedUsersContainer>
              <Icon name="group" size="small"/>
              <Typography category="body" size="small" weight="regular" color="body">
                +34
              </Typography>}
            </AssisnedUsersContainer>*/}
            <Button
              label="View details"
              size="small"
              type="tertiary"
              disableEffects={true}
              onClick={handleViewDetails}
            />
            <ButtonMenu
              customIcon="dotsMenu"
              disableEffects
              iconPosition="right"
              label=""
              menuPosition="top"
              alignMenu="left"
              onChange={handleMenuChange}
              size="medium"
              type="tertiary"
              width="auto"
              usePortal={true}
            >
              <ButtonMenu.Menu icon={true}>
                <ButtonMenu.Item
                  label="Assign role"
                  value="assign_role"
                />
              </ButtonMenu.Menu>
            </ButtonMenu>
          </RightSpace>
        </CardWrapper>
      </Card>
    </div>
  );
};

export default RoleCard;

